import Actions from 'redux/actions'
import type { CallAPIAction, Status } from 'api/types'
import { EVISA_AUTH_HEADER } from 'common/constants'
import { AuthHeader } from 'api/evisaAPI/auth'

type State = { token?: string } & Status

const initialState = {
  isLoading: false,
  success: false,
  fail: false,
  token: undefined,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.REGISTER_VERIFY_MOBILE_ASYNC,
    Actions.REGISTER_VERIFY_MOBILE_SUCCESS,
    Actions.REGISTER_VERIFY_MOBILE_FAIL,
    {},
    {},
    AuthHeader
  >,
): State => {
  switch (action.type) {
    case Actions.REGISTER_VERIFY_MOBILE_SUCCESS: {
      const token = action.headers[EVISA_AUTH_HEADER]

      return {
        ...state,
        ...action.status,
        token,
      }
    }
    case Actions.REGISTER_VERIFY_MOBILE_ASYNC:
    case Actions.REGISTER_VERIFY_MOBILE_FAIL: {
      return {
        ...state,
        ...action.status,
      }
    }
    default:
      return state
  }
}
